import { Box } from '@mui/material'
import Pressable from '@/theme/Pressable'
import { formatReplyCardTimestamp } from '@/utils/formatReplyCardTimestamp'
import { getReplyPreviewSnippet } from '@/utils/replyPreviewSnippet'
import styles from './index.module.scss'

export default function SentMessageReplyPreview({ replyTo, onJumpToQuotedMessage }) {
  const when = formatReplyCardTimestamp(replyTo.createdAt)
  const snippet = getReplyPreviewSnippet(replyTo.text, replyTo.attachmentCount)
  const isInteractive = !!(onJumpToQuotedMessage && replyTo.messageId)

  const content = (
    <>
      <Box className={styles.sentReplyPreviewAccent} aria-hidden />
      <Box className={styles.sentReplyPreviewMain}>
        <Box className={styles.sentReplyPreviewMeta}>
          <Box component="span" className={styles.sentReplyPreviewName}>
            {replyTo.authorName}
          </Box>
          {when ? (
            <Box component="span" className={styles.sentReplyPreviewTime}>{` ${when}`}</Box>
          ) : null}
        </Box>
        <Box className={styles.sentReplyPreviewSnippet} title={snippet}>
          {snippet}
        </Box>
      </Box>
    </>
  )

  if (isInteractive) {
    return (
      <Pressable
        className={`${styles.sentReplyPreviewCard} ${styles.sentReplyPreviewCardInteractive}`}
        aria-label={`Go to original message from ${replyTo.authorName}`}
        onClick={(e) => {
          e.stopPropagation()
          onJumpToQuotedMessage?.(replyTo.messageId)
        }}
      >
        {content}
      </Pressable>
    )
  }

  return (
    <Box className={styles.sentReplyPreviewCard} role="figure" aria-label={`Reply to ${replyTo.authorName}`}>
      {content}
    </Box>
  )
}
